import { IconButton } from "@mui/material";

export default (props) => {
  return <IconButton size="small" {...props} />;
};
